const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"198f3dc22cefdf8792e686df4eb328393b9b4200"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["dodo-lite@dodoex"]={id:"198f3dc22cefdf8792e686df4eb328393b9b4200"};
      